import { Icon } from "semantic-ui-react";

import "components/Pagination/components/ArrowPagination/ArrowPagination.scss";

type ArrowPaginationProps = {
  disabledNext: boolean;
  disabledPrevious: boolean;
  onClickNext: () => void;
  onClickPrevious: () => void;
};

export const ArrowPagination = ({ disabledPrevious, disabledNext, onClickPrevious, onClickNext }: ArrowPaginationProps) => (
  <div className="ArrowPagination">
    <div className="pagination-button">
      <button className="nav-button" disabled={disabledPrevious} onClick={onClickPrevious}>
        <Icon className="angle left" />
      </button>
    </div>

    <div className="pagination-button">
      <button className="nav-button" disabled={disabledNext} onClick={onClickNext}>
        <Icon className="angle right" />
      </button>
    </div>
  </div>
);
